
import React from 'react';

export const ResetPasswordFooter: React.FC = () => {
  return (
    <div className="text-center">
      <p className="text-sm text-muted-foreground">
        Remember your password?{' '}
        <a href="/login" className="text-primary hover:underline">
          Back to login
        </a>
      </p>
    </div>
  );
};
